import { CheckCircle, Upload } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import React, { useRef, useState } from "react";
import { storageService } from "../firebase-config";

const GREEN = "#00C853";
const DARK = "#0D1420";

interface UploadImageButtonProps {
  path: string;
  label?: string;
  icon?: React.ReactNode;
  onUploaded: (url: string) => Promise<void> | void;
  color?: "green" | "dark";
  sx?: object;
}

const UploadImageButton: React.FC<UploadImageButtonProps> = ({
  path,
  label = "Subir Imagen",
  icon = <Upload />,
  onUploaded,
  color = "dark",
  sx = {},
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClick = () => fileInputRef.current?.click();

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      setLoading(true);
      setSuccess(false);
      const fileRef = ref(storageService, `${path}`);
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);
      await onUploaded(url);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error("Error subiendo archivo:", err);
    } finally {
      setLoading(false);
    }
  };

  const bgColor = success ? GREEN : color === "green" ? GREEN : DARK;

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <Button
        onClick={handleClick}
        fullWidth
        variant="contained"
        startIcon={
          loading ? (
            <CircularProgress size={18} sx={{ color: "white" }} />
          ) : success ? (
            <CheckCircle sx={{ color: "white" }} />
          ) : (
            icon
          )
        }
        disabled={loading}
        sx={{
          bgcolor: bgColor,
          color: "white",
          fontWeight: 700,
          fontSize: 13,
          borderRadius: "50px",
          py: 1,
          px: 2,
          textTransform: "none",
          boxShadow: "none",
          mt: 0,
          "&:hover": { bgcolor: color === "green" ? "#00b048" : "#1a2840", boxShadow: "none" },
          "&:disabled": { bgcolor: "#cccccc", color: "white" },
          ...sx,
        }}
      >
        {loading ? "Subiendo..." : success ? "¡Listo!" : label}
      </Button>
    </>
  );
};

export default UploadImageButton;
